import { Alert } from '@mui/material';
import tid from '@/common/application/utils/tid';
import { STATUS_COLORS, CERTPERM_COLORS } from '@/common/presentation/constants/colors';

const alertSx = {
  padding: '6px 16px',
  alignItems: 'center',
  borderRadius: '4px',
  border: `1px solid ${STATUS_COLORS.WARNING_MAIN}`,
  backgroundColor: 'transparent',
  minHeight: '38px',
  boxSizing: 'border-box',
  '& .MuiAlert-message': {
    color: CERTPERM_COLORS.WARNING,
    fontFamily: 'Lato, sans-serif',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '143%',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    height: '24px'
  },
  '& .MuiAlert-icon': {
    color: STATUS_COLORS.WARNING_MAIN,
    padding: 0,
    marginRight: '8px',
    fontSize: '24px',
    display: 'flex',
    alignItems: 'center',
    height: '24px'
  }
} as const;

export function EquipmentComplianceWarningAlert() {
  return (
    <Alert severity="warning" {...tid('jobs:create:equipment-compliance-warning')} sx={alertSx}>
      The selected equipment does not meet the required certifications for this job.
    </Alert>
  );
}
